export default __webpack_public_path__ + "static/media/img_loud.a22d525a.png";